import styled from "@emotion/styled";
import * as React from "react";

import { Heading, SpacingToken } from "@livechat/design-system-react-components";

import { Loader, LoaderSize } from "components/loader/Loader";
import { ITicket } from "interfaces/entities/ticket";

import { MergeTicketBanner } from "./MergeTicketBanner";
import { TicketOption } from "./TicketOption";
import { TicketsToMergeNoData } from "./TicketsToMergeNoData";

interface ITicketsToMergeProps {
  ticketsToMerge: ITicket[];
  ticket: ITicket;
  setChildTickets: (ticketIds: string[]) => void;
  selectedChildTicketsIds: string[];
  isLoading: boolean;
}

const Wrapper = styled.div`
  overflow: auto;
`;

const SectionHeading = styled(Heading)`
  margin: var(${SpacingToken.Spacing2}) 0;
`;

const LoaderWrapper = styled.div`
  position: relative;
  margin-top: 60px;
`;

export const TicketsToMerge: React.FC<ITicketsToMergeProps> = ({
  ticket,
  ticketsToMerge,
  setChildTickets,
  selectedChildTicketsIds,
  isLoading,
}) => (
  <Wrapper>
    <MergeTicketBanner />
    <SectionHeading size="xs">Main Ticket</SectionHeading>
    <TicketOption
      hasCheckbox={false}
      ticket={ticket}
      selectedChildTicketsIds={selectedChildTicketsIds}
      setChildTickets={setChildTickets}
    />
    <SectionHeading size="xs">Select sub tickets to merge</SectionHeading>
    {isLoading ? (
      <LoaderWrapper>
        <Loader size={LoaderSize.Small} />
      </LoaderWrapper>
    ) : (
      <>
        {ticketsToMerge.length ? (
          ticketsToMerge.map(
            (item, i) =>
              i < 10 && (
                <TicketOption
                  hasCheckbox
                  key={item.id}
                  ticket={item}
                  setChildTickets={setChildTickets}
                  selectedChildTicketsIds={selectedChildTicketsIds}
                />
              )
          )
        ) : (
          <TicketsToMergeNoData />
        )}
      </>
    )}
  </Wrapper>
);
